export {
  mergeViewingTagIntoArg,
  viewingInvestorTagMergeUsesCallersInvestorTagId,
} from './viewingTagSelection';
